import cx from 'classnames';
import {Drawer as Vaul} from 'vaul';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {CloseLineIcon} from '~library/svg/CloseLineIcon';

import './TabsContainer.sass';

interface TabsContainerProps<T = string | number | null> {
  tabs: T[];
  activeTab: T | null;
  handleCloseClick?: () => void;
  handleTabClick: (newTab: T) => void;
}
export function TabsContainer<T>({
  tabs,
  activeTab,
  handleCloseClick,
  handleTabClick,
}: TabsContainerProps<T>) {
  return (
    <div className="tabs-container__wrapper">
      <div className="tabs-container">
        {tabs.map((tab) =>
          tab ? (
            <Button
              variant="unstyled-button"
              key={tab.toString()}
              onClick={() => handleTabClick(tab)}
              data-qa-id={tab.toString()}
            >
              <Typography
                variant="label2"
                classNames={cx('tabs-container--tab', {
                  'tabs-container--underline': tab === activeTab,
                })}
              >
                {tab.toString()}
              </Typography>
            </Button>
          ) : null
        )}
      </div>

      {handleCloseClick && (
        <Vaul.Close asChild>
          <CloseLineIcon ratio={0.75} onClick={handleCloseClick} />
        </Vaul.Close>
      )}
    </div>
  );
}
